module.exports = __webpack_public_path__ + "assets/f8c3f2c52d829c6691b3af3a95b0e422.svg";